import { createContext } from 'react';

export const OnboardingContext = createContext({});

export const OnboardingProvider = OnboardingContext.Provider;
export const OnboardingConsumer = OnboardingContext.Consumer;
